import React from 'react';
import { isEmpty } from 'lib/utils';
import Box from 'components/shared/generic/box/presentational/Box';
import Typography from 'components/shared/generic/typography/presentational/Typography';

interface DataCheckProps {
    children: React.ReactNode;
    isLoading?: boolean;
    data?: unknown;
    error?: unknown;
    noDataMessage?: string;
    className?: string;
    loadingMessage?: string;
}

const DataCheck = ({
    children,
    data,
    isLoading,
    error,
    noDataMessage = 'There is no data to display.',
    className,
    loadingMessage,
}: DataCheckProps) => {
    if (isLoading) {
        return (
            <Box>
                <Typography className="data-check-loading loading-spinner">
                    <i className="far fa-spinner fa-spin" />
                    {loadingMessage}
                </Typography>
            </Box>
        );
    }

    if (error) {
        if (typeof error === 'string') {
            return <Typography className="data-check-error">{error}</Typography>;
        }

        return null;
    }

    if (data == null || isEmpty(data)) {
        return (
            <Typography className="data-check-no-data">{noDataMessage}</Typography>
        );
    }

    return <Box className={className}>{children}</Box>;
};

export default DataCheck;
